/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetReportControllerGetAllParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen
} from "../../v1/data-contracts";
import { FleetReport } from "../../v1/FleetReport";

export class ReportFleetService {
  /**
   * The proxy.
   */
  proxy: FleetReport;

  /**
   * @class Initialize ReportMeService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetReport(clientProvider.client());
  }

  async findAll(query: MrfiktivFleetReportControllerGetAllParamsGen, data: MrfiktivMultipleIdsDtoOptionalGen) {
    return (await this.proxy.fleetReportControllerGetAllPost(query, data)).data;
  }

  async findOne(partnerId: string, fleetId: string, id: string) {
    return (await this.proxy.fleetReportControllerGetOne(partnerId, fleetId, id)).data;
  }

  async createDamageReportPdf(
    partnerId: string,
    fleetId: string,
    reportId: string,
    imageTypes?: string[]
  ): Promise<Buffer> {
    const bufferObject = (
      await this.proxy.fleetReportControllerGetDamageReportPdf({
        partnerId,
        fleetId,
        reportId,
        imageTypes: imageTypes as any
      })
    ).data;

    return Buffer.from(Object.values(bufferObject));
  }
}

export default new ReportFleetService(new MrfiktivHttpClientProvider());
